import { RouteType } from '@/types/RouteType';

export function invoiceCfeRoutePage(route: RouteType): RouteType {
  return { ...route, routes: route.parent.routes };
}
